<template>
  <div @click="authExpiryCheck()">
  <div id="loader" style="display: none;">
    <!--
    <div class="preloader spinner-border" style="width: 4rem; height: 4rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    -->
    <img id="logoLoader" src="./assets/spinner.png"/>

    <p class="logoLoader">
      Loading...
    </p>

    <div id="background"></div>
  </div>
  <div id="navbarComponent">
    <nav class="navbar fixed-top navbar-expand-lg bg-body-tertiary d-flex flex-column">
      <div class="container-fluid">
        <button @click="visible = !visible" v-if="inSection" class="btn" id="sectionmenu" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
          <span class="navbar-toggler-icon"></span>
        </button>

        <a @click="visible = !visible" class="navbar-brand ps-lg-3 me-lg-5">
          <router-link to="/">
            <img class="mb-1" src="./assets/favicon.png" style="width: 30px;" alt="logo"/>
            <span v-if="!inHomeOrAbout" class="ps-2 fira" id="brand">assess.org.ng</span>
            <span v-if="inHomeOrAbout" class="ps-2 fira">assess.org.ng</span>
          </router-link>
        </a>
        <button class="btn" id="navmenu" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span><i class="fa-solid fa-ellipsis-vertical mx-2 fa-xl" style="color: grey;"></i></span>
        </button>
        <div class="collapse navbar-collapse" :class="{ collapse: visible }" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0" @click="visible = !visible">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" href="#"><router-link to="/">Home</router-link></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#"><router-link to="/about">About</router-link></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://wa.me/2347038775998" target="_blank"><b style="color: #2c3e50;">Ask for Help</b></a>
            </li>
            <li v-if="isLoggedIn && !inSection" class="nav-item">
              <a class="nav-link" href="#"><router-link to="/sectiona">Appraisal Form</router-link></a>
            </li>
          </ul>
          <div hidden id="darkToggle" class="nav-item" @click="visible = !visible">
            <a class="nav-link" href="#">
              <b><i style="color: rgb(0, 83, 139); font-size: larger;" class="bi bi-moon-stars-fill"></i>&nbsp; Dark Mode</b>
            </a>
          </div>
          <div hidden id="lightToggle" class="nav-item" style="display: none;" @click="visible = !visible">
            <a class="nav-link" href="#">
              <b><i style="color: orange; font-size: larger;" class="bi bi-brightness-high-fill"></i>&nbsp; Light Mode</b>
            </a>
          </div>
          <div>
            <button @click="logout()" v-if="isLoggedIn" class="btn btn-outline-success"><b>Log out</b></button>
          </div>
        </div>
      </div>
      <div v-if="isLoggedIn && inSection" style="width: 100vw;">
        <div v-if="submitted" class="marquee submittedBadge mt-2" height="26px" scrollamount="3" style="margin-bottom: -20px; font-size: 15px;">
          <span style="color: darkgreen;"><i class="fa-regular fa-circle-dot fa-xs"></i> Submitted for appraisal</span>
        </div>
        <div v-if="!submitted" class="marquee notSubmittedBadge mt-2" height="26px" scrollamount="3" style="margin-bottom: -20px; font-size: 15px;">
          <span style="color: darkred;"><i class="fa-regular fa-circle-dot fa-xs"></i> Not submitted for appraisal</span>
        </div>
      </div>
    </nav>
    
  </div>

  <!--Offcanvas-->
  <div class="offcanvas offcanvas-start w-50" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel"><b>Sections</b></h5>
      <button id="offcanvasClose" type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <div class="text-start" style="color: red; margin-left: -10px;">
          <ul @click="hideOffcanvas()" v-if="inSection && (isAcademicStaff || isResearchStaff || isLibraryStaff)">
              <li class="p-2 secItem rounded-2" id="Section A"><router-link class="ms-2" style="color: black;" to="/sectiona">Section A</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section B"><router-link class="ms-2" style="color: black;" to="/sectionb">Section B</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section C"><router-link class="ms-2" style="color: black;" to="/sectionc">Section C</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section D"><router-link class="ms-2" style="color: black;" to="/sectiond">Section D</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section E"><router-link class="ms-2" style="color: black;" to="/sectione">Section E</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section F"><router-link class="ms-2" style="color: black;" to="/sectionf">Section F</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section G"><router-link class="ms-2" style="color: black;" to="/sectiong">Section G</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section H"><router-link class="ms-2" style="color: black;" to="/sectionh">Section H</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section I"><router-link class="ms-2" style="color: black;" to="/sectioni">Section I</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section J & K"><router-link class="ms-2" style="color: black;" to="/sectionj&k">Section J & K</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section L"><router-link class="ms-2" style="color: black;" to="/sectionl">Section L</router-link></li>
            </ul>
            <ul @click="hideOffcanvas()" v-if="inSection && (isSeniorNonacademic || isJuniorNonacademic)">
              <li class="p-2 secItem rounded-2" id="Section I"><router-link class="ms-2" style="color: black;" to="/section1">Section 1</router-link></li>
              <li class="p-2 secItem rounded-2" id="Section II"><router-link class="ms-2" style="color: black;" to="/section2">Section 2</router-link></li>
            </ul>
      </div>
    </div>
  </div>

  <div v-if="!inSection" style="padding-top: 6vh;"></div>

  <div v-if="inSection" style="padding-top: 10vh;"></div>

  <div @click="visible=!visible">
    <div class="mb-4">
      <div v-if="inSection && (isAcademicStaff || isResearchStaff || isLibraryStaff)" class="form lato">
        <h4 class="mt-4 mainHeader py-3">
          <b>
            <span v-if="isAcademicStaff">ACADEMIC TEACHING</span> <span v-if="isResearchStaff">RESEARCH</span> <span v-if="isLibraryStaff">LIBRARY</span> STAFF FORM
          </b>
        </h4>
        <div class="text-start my-4 ms-2 section">
            <!-- Split dropend button -->
            <div class="btn-group dropend">
              <button type="button" class="btn btn-outline-success dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" style="font-weight: bold;">
                <i class="fa fa-list-ul" aria-hidden="true"></i> 
                &nbsp;<span>{{ section }}</span>&nbsp;
              </button>
              <ul class="dropdown-menu text-center">
                <li><router-link class="dropdown-item" to="/sectiona">Section A</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectionb">Section B</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectionc">Section C</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectiond">Section D</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectione">Section E</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectionf">Section F</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectiong">Section G</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectionh">Section H</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectioni">Section I</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectionj&k">Section J & K</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/sectionl">Section L</router-link></li>
              </ul>
            </div>
        </div>
      </div>
      <div v-if="inSection && (isSeniorNonacademic || isJuniorNonacademic)">
        <div v-if="inSection && isSeniorNonacademic" class="form lato">
          <h4 class="my-4 mainHeader py-3">
            <b>
              SENIOR NON-ACADEMIC STAFF FORM
            </b>
          </h4>
        </div>
        <div v-if="inSection && isJuniorNonacademic" class="form lato">
          <h4 class="my-4 mainHeader py-3">
            <b>
              JUNIOR NON-ACADEMIC STAFF FORM
            </b>
          </h4>
        </div>
        <div class="text-start my-4 ms-4 section">
            <!-- Split dropend button -->
            <div class="btn-group dropend">
              <button type="button" class="btn btn-outline-success dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" style="font-weight: bold;">
                <i class="fa fa-list-ul" aria-hidden="true"></i> &nbsp;
                {{ section }} &nbsp;
              </button>
              <ul class="dropdown-menu text-center">
                <li><router-link class="dropdown-item" to="/section1">Section 1</router-link></li>
                <li><hr class="dropdown-divider"></li>
                <li><router-link class="dropdown-item" to="/section2">Section 2</router-link></li>
              </ul>
            </div>
        </div>
      </div>
    </div>
    
    <div id="lato" @click="hideNav()">
      <router-view @toggleLoader="toggleLoader" @setSection="setSection" @submitted="setBadge"/>
    </div>
  </div>
</div>
</template>

<script>
import DataService from './services/dataservice';

export default {
  name: 'App',
  data() {
    return {
      visible: false,
      section: '',
      submitted: ''
    }
  },
  computed: {
    isLoggedIn() {
      return DataService.isLoggedIn();
    },
    inHomeOrAbout() {
      return (
        this.$router.currentRoute.value.path == "/" || 
        this.$router.currentRoute.value.name == "about" || 
        this.$router.currentRoute.value.name == "assessor" || 
        this.$router.currentRoute.value.name == 'candidate' ||
        this.$router.currentRoute.value.name == 'assign' ||
        this.$router.currentRoute.value.name == 'result' ||
        this.$router.currentRoute.value.name == 'login' ||
        this.$router.currentRoute.value.name == 'register' ||
        this.$router.currentRoute.value.name == 'nonacademiccandidatelist' ||
        this.$router.currentRoute.value.name == 'nonacademiccandidate' 
      )
    },
    inSection() {
      return this.$router.currentRoute.value.path.includes('/section')
    },
    isAcademicStaff() {
      return this.$store.state.user.staffType == 'Academic Teaching'
    },
    isResearchStaff(){
      return this.$store.state.user.staffType == 'Research'
    },
    isLibraryStaff() {
      return this.$store.state.user.staffType == 'Library'
    },
    isSeniorNonacademic() {
      return this.$store.state.user.staffType == 'Senior Non-academic'
    },
    isJuniorNonacademic() {
      return this.$store.state.user.staffType == "Junior Non-academic"
    }
  },
  created() {
    this.storeUser()
  },
  mounted(){
    this.initialize()
  },
  methods: {
    authExpiryCheck(){
      if (this.$store.state.user) {
        var payload = JSON.parse(atob(this.$store.state.user.token.split(".")[1]))

        if(Date.now() > (payload.exp * 1000)) {
          this.$store.commit('disconnect');
          if (this.inSection) {
            alert('Your session has expired. Please log in again.')
            this.$router.push({ path: `/login` });
          }
          document.getElementById('loader').style.display = 'none'
        }
      }
    },
    hideNav(){
      document.getElementById('navbarSupportedContent').classList.add('collapse')
    },
    hideOffcanvas(){
      document.getElementById('offcanvasClose').click()
    },
    logout() {
      this.visible ? this.visible = false : this.visible = true
      this.$store.commit('disconnect');
      this.$router.push({ path: `/` });
    },
    toggleLoader() {
      if (this.inSection && !this.isLoggedIn) {
        alert("You're not logged in. Please log in.")
        document.getElementById('loader').style.display = 'none'
        this.$router.push({ path: `/login` })
        return
      }

      if (document.getElementById('loader').style.display == 'block') {
        document.getElementById('loader').style.display = 'none'
      } else {
        document.getElementById('loader').style.display = 'block'
      }
    },
    storeUser() {
      //if no user in store and user in localstorage
      if (!this.$store.state.user && window.localStorage['user']) {
        this.$store.commit('connect', JSON.parse(window.localStorage['user']))
      }
    },
    setSection(section) {
      this.section = section

      const sections = document.querySelectorAll('.secItem');

      sections.forEach(sec => {
        sec ? sec.style.backgroundColor = 'white' : '';
      })

      const sect = document.getElementById(this.section);
      sect ? sect.style.backgroundColor = '#E5E4E2' : '';
    },
    setBadge(submitted){
      this.submitted = submitted
    },
    initialize(){
      const body = document.getElementById('body');
      const section = document.getElementById('lato')
      const loader = document.getElementById('background');
      const lightToggle = document.getElementById('lightToggle');
      const darkToggle = document.getElementById('darkToggle');
      const navlinks = document.querySelectorAll('a');
      const activeNavlinks = document.querySelectorAll('a:hover');
      const brand = document.querySelector('a.navbar-brand');

      function setTheme(mode){
        if (mode == 'light') {
          darkToggle.style.display = 'block';
          lightToggle.style.display = 'none'
          body.setAttribute('data-bs-theme', mode);
          window.sessionStorage['mode'] = mode;
          
          section.classList.remove('dark');
          section.classList.add('light');

          loader.style.backgroundColor = 'white';

          navlinks.forEach(navlink => {
            navlink.style.setProperty('color', '#212529');
          })
          activeNavlinks.forEach(navlink => {
            navlink.style.setProperty('color', 'rgb(58, 143, 83)', 'important')
          })
          brand.style.setProperty('color', '#212529');
        } else if (mode == 'dark'){
          darkToggle.style.display = 'none';
          lightToggle.style.display = 'block';
          body.setAttribute('data-bs-theme', mode);
          window.sessionStorage['mode'] = mode;

          section.classList.remove('light');
          section.classList.add('dark');

          loader.style.backgroundColor = '#212529';

          navlinks.forEach(navlink => {
            navlink.style.setProperty('color', 'white');
          })
          activeNavlinks.forEach(navlink => {
            navlink.style.setProperty('color', 'rgb(58, 143, 83)', 'important')
          })
          brand.style.setProperty('color', 'white');
        }
      }

      if (window.sessionStorage['mode']){
        setTheme(window.sessionStorage['mode'])
      }

      lightToggle.addEventListener('click', ()=>{setTheme('light')})
      darkToggle.addEventListener('click', ()=>{setTheme('dark')})
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Nunito&display=swap&family=Fira+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.marquee {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
}

/* FOR SLIDING MARQUEE
.marquee span {
  display: inline-block;
  padding-left: 100%;
  animation: scroll 36s linear infinite;
}
*/

.marquee span {
  display: inline-block;
}

@keyframes scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}

.submittedBadge {
  background-color: rgb(222, 240, 222);
}

.notSubmittedBadge {
  background-color: rgb(240, 222, 222);
}

.fira {
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  font-style: italic;
  font-size: 20px;
  color: black;
}

.firaFooter {
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  font-style: italic;
}

#logoLoader {
  top: 33vh;
  left: 40vw;
  position: fixed;
  z-index: 9999;
  width: 90px;
  animation: spin 1s ease-in-out infinite;
}

.logoLoader {
  top: 60vh;
  left: 41vw;
  position: fixed;
  z-index: 9999;
  font-style: italic;
  font-size: larger;
  color: grey;
}

@keyframes spin {
  from { transform: rotate(360deg); }
  to { transform: rotate(0deg); }
}

@media (min-width: 1400px) {
  #logoLoader {
    left: 50vw;
  }
  .logoLoader {
    left: 50vw;
  }
}

/*
.preloader {
    color: rgb(58, 143, 83);
    top: 40vh;
    left: 42vw;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9999;
    border-width: 5px;
}

@media (min-width: 1400px) {
  .preloader {
    left: 50vw;
  }
}
*/

#home {
  background: linear-gradient(rgb(255, 255, 255), rgba(219, 219, 219, 0.8)), url('./assets/background.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 0% 0% 10% 10%;
  padding-bottom: 100px;
  margin-top: -12px !important;
}

.signInBtn {
  color: rgba(0, 0, 0, 0.7); 
  background-color: rgba(128, 128, 128, 0.2);
  backdrop-filter: blur(10px);          /* blurs background behind it */
  -webkit-backdrop-filter: blur(10px);  /* Safari support */
}

#homeListing {
  position: relative;
  top: -40px;
}

@media (min-width: 993px) {
  .homeListingContainer {
    width: 1000px;
  }
}

.footer {
  background: linear-gradient(rgb(255, 255, 255), rgba(255, 255, 255, 0.5)), url('./assets/footerbackground.jpg');
  background-size: cover;
  background-position: center;
}

@media (max-width: 576px) {
  .read {
    font-size: 0.98rem; /* same as Bootstrap fs-6 */
  }
}

.homeCard {
  width: 350px; 
  box-shadow: 0 0 20px rgba(92, 107, 92, 0.25);
  border-radius: 15px;
  border: none;
  padding-top: 20px;
}

.homeCardIcon {
  border: 1px dashed silver; 
  color: #198754
}

div.mb-3 {
  text-align: justify;
}

.nunito {
  font-family: "Nunito", sans-serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

#lato {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-style: normal;
}

@media (max-width: 768px) {
  #lato, button.dropdown-toggle > span, ul.dropdown-menu, input.form-control, input[type] {
    font-size: 15px !important;
  }
  h5 {
    font-size: 15px;
  }
  .mainHeader {
    font-size: 20px;
  }
  button.btn > i, a.btn {
    font-size: 15px;
  }
  .section {
    display: none;
  }
  #brand {
    display: none;
  }
}

.lead {
  font-weight: 300;
  font-family: 'Lato', sans-serif;
}

a {
  text-decoration: none !important;
}

#app,
button,
div>a {
  font-family: "Nunito", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

button.accordion-button, .table {
  font-family: 'Lato', sans-serif !important;
}

button.accordion-button {
  font-size: 15px;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
  font-size: 16px;
}

p>a {
  color: #2c3e50;
  font-size: 20px
}

select.assessor {
  font-size: 20px;
  width: 350px;
}

nav a.router-link-exact-active {
  color: #42b96a !important;
}

.form {
  /*font-family: 'Times New Roman', Times, serif;*/
  margin: 0% 2% 0%;
}

.form h1 {
  line-height: 60%;
}

div>select {
  padding: 5px;
  border: none;
  border-bottom: 1px solid #a2a2a2;
  width: 260px
}

td>select, span>select, span>input {
  padding: 4px;
  width: 60px
}

.spinner {
  width: 70px;
  text-align: center;
  margin-top: 10px;
}

.spinnersession {
  text-align: right;
  margin-top: 3px;
}

td>input {
  width: 70px;
  padding-left: 10px
}

h5,
p {
  text-align: left;
}

h5.mt-3, h5.px-5 {
  text-align: center;
}

input[type=text],
input[type=number],
input[type=date],
input[type=password],
textarea[type=text],
select[name] {
  background: transparent;
  border: none;
  border-bottom: 1px solid #a2a2a2;
  border-bottom-left-radius: 0%;
  border-bottom-right-radius: 0%;
  border-top-left-radius: 0%;
  border-top-right-radius: 0%;
  width: 100%;
  margin-top: 10px;
  padding-bottom: 10px !important;
}

textarea:focus, 
input[type=text]:focus, 
input[type=number]:focus,
input[type=date]:focus, 
input[type=password]:focus, 
select[name]:focus {
  box-shadow: none !important;
  border-bottom: 2px solid rgb(58, 143, 83) !important;
}

.navbar {
  box-shadow: 0px 2px 15px rgba(149, 149, 149, 0.265);
}

span>b,
input,
label {
  font-size: 17px !important;
}

ol.breadcrumb {
  margin-left: -25px;
  font-size: 20px;
}

input.picker[type="date"] {
  position: relative;
}

input.picker[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  color: transparent;
  background: transparent;
}

input[type=date]:required:invalid::-webkit-datetime-edit {
  color: transparent;
}

input[type=date]:focus::-webkit-datetime-edit {
  color: black !important;
}

/*
.table-borderless>tbody>tr>td,
.table-borderless>tbody>tr>th,
.table-borderless>tfoot>tr>td,
.table-borderless>tfoot>tr>th,
.table-borderless>thead>tr>td,
.table-borderless>thead>tr>th {
  border: 1px solid black;
}*/

th>b {
  color: rgb(58, 143, 83);
}



#background {
  align-items: center;
  background-color: white;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 9997;
  top: 0px;
  bottom: 0px;
}

label.form-check-label {
  font-size: 15px !important;
}

.notes {
  font-size: 14px; 
  color: rgb(58, 143, 83) !important;
  font-family: "Nunito", sans-serif !important;
}

.mainHeader {
  color: rgb(58, 143, 83) !important;
  font-family: "Nunito", sans-serif !important;
}

.form-check-input {
  border-color: rgb(129, 129, 129) !important;
}

.form-check-input:checked {
    background-color: rgb(58, 143, 83) !important;
    border-color: rgb(58, 143, 83) !important;
}

.form-check-input:focus {
  box-shadow: none !important;
}

.dropdown-item:focus, .dropdown-item:hover {
  color: white !important;
  background-color: rgb(58, 143, 83) !important;
}

/*SIDE DROP DOWN BESIDE ITEMS COLOR */
.delete {
  color: rgb(230, 0, 0);
}
.delete:hover {
  color: white;
}

.justify {
  text-align: justify;
}
div.nav-item {
  margin-right: 20px;
}
@media (max-width: 768px) {
  div.nav-item {
    margin-bottom: 20px;
  }
}

@media (min-width: 993px) {
  #navmenu, #sectionmenu {
    display: none;
  }

}

/*FOR MODAL TEXTAREA INPUT*/
span > textarea {
  margin-top: 5px !important;
  padding-top: 0px !important;
}

label.form-label {
  margin-bottom: 0px !important;
}

.light {
  color: #212529
}
.dark {
  color: white
}
select {
  color: black
}
a.page-link {
  color: green;
}
</style>
